module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching
    }
  })], 1), _vm._v(" "), (!_vm.isFetching) ? _c('div', {
    staticClass: "col-12"
  }, [_c('h2', {
    staticClass: "display-4"
  }, [_vm._v("Aankoop kosten")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tAantal kavels: " + _vm._s(_vm.costs.item_count) + "\n\t\t\t")]), _vm._v(" "), (_vm.error) ? _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.formError) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, _vm._l((_vm.formError.errors), function(errors, i) {
    return _c('span', {
      key: i
    }, _vm._l((errors), function(error, j) {
      return _c('span', {
        key: (i + "-" + j)
      }, [_vm._v(_vm._s(error)), _c('br')])
    }), 0)
  }), 0) : _vm._e(), _vm._v(" "), _c('b-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('buyerCost.buyerTotal')))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-euro-sign fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "text-right",
    attrs: {
      "type": "number",
      "disabled": "",
      "value": Number(_vm.costs.item_cost).toFixed(2)
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('buyerCost.commission')) + " "), _c('small', [_vm._v("(" + _vm._s(Number(_vm.costs.commission_percentage).toFixed(2)) + "%)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-euro-sign fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "text-right",
    attrs: {
      "type": "number",
      "disabled": "",
      "value": Number(_vm.costs.commission).toFixed(2)
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('buyerCost.fixedCommissionPercentage')))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-percentage fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "text-right",
    attrs: {
      "type": "number",
      "step": "any",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.fixed_commission_percentage),
      callback: function($$v) {
        _vm.$set(_vm.form, "fixed_commission_percentage", $$v)
      },
      expression: "form.fixed_commission_percentage"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.$t('buyerCost.tableMoney')))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-euro-sign fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "text-right",
    attrs: {
      "type": "number",
      "disabled": "",
      "autocomplete": "off",
      "value": Number(_vm.costs.table_money).toFixed(2)
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Verzendkosten")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-euro-sign fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "text-right",
    attrs: {
      "type": "number",
      "step": "any",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.shipping_cost),
      callback: function($$v) {
        _vm.$set(_vm.form, "shipping_cost", $$v)
      },
      expression: "form.shipping_cost"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Administratiekosten")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-euro-sign fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "text-right",
    attrs: {
      "type": "number",
      "step": "any",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.administration_cost),
      callback: function($$v) {
        _vm.$set(_vm.form, "administration_cost", $$v)
      },
      expression: "form.administration_cost"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Korting")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-euro-sign fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "text-right",
    attrs: {
      "type": "number",
      "step": "any",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.discount),
      callback: function($$v) {
        _vm.$set(_vm.form, "discount", $$v)
      },
      expression: "form.discount"
    }
  })], 1)], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v("Factuurbedrag")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('h5', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.costs.total_cost)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v("Betaald")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('h5', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.costs.total_paid)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v("Openstaand")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('h5', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.costs.remaining_cost)))])])]), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "pull-right",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "title": "Opslaan"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-save"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isFetching) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('h3', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('common.payments')))]), _vm._v(" "), (!_vm.isFetching) ? _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "show-empty": "",
      "items": _vm.costs.payments,
      "fields": _vm.paymentList.fields,
      "per-page": 5,
      "sort-by": _vm.paymentList.sortBy,
      "sort-desc": _vm.paymentList.sortDesc,
      "busy": _vm.isFetching,
      "empty-text": _vm.$t('payment.listEmptyText')
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.paymentList, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.paymentList, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.paymentList, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.paymentList, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "cell(type)",
      fn: function(row) {
        return [(row.item.type) ? _c('span', [_vm._v(_vm._s(_vm.$t(("payment." + (row.item.type)))))]) : _vm._e()]
      }
    }, {
      key: "cell(amount)",
      fn: function(row) {
        return [(row.item.amount) ? _c('span', [_vm._v(_vm._s(("€ " + (row.item.amount.replace('.', ',')))))]) : _vm._e()]
      }
    }, {
      key: "cell(date)",
      fn: function(row) {
        return [(row.item.date) ? _c('span', [_vm._v(_vm._s(_vm.convertDate(row.item.date)))]) : _vm._e()]
      }
    }, {
      key: "cell(actions)",
      fn: function(row) {
        return [_c('b-button-group', {
          staticClass: "pull-right"
        }, [_c('b-btn', {
          attrs: {
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              return _vm.showDeleteModal(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-trash"
        })])], 1)]
      }
    }], null, false, 1469434106)
  }) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "mt-4"
  }, [_vm._v(_vm._s(_vm.$t('payment.addPayment')))]), _vm._v(" "), _c('b-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createPayment($event)
      }
    }
  }, [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('multiselect', {
    attrs: {
      "label": "label",
      "options": _vm.paymentForm.types,
      "show-labels": false,
      "searchable": false
    },
    model: {
      value: (_vm.paymentForm.selectedType),
      callback: function($$v) {
        _vm.$set(_vm.paymentForm, "selectedType", $$v)
      },
      expression: "paymentForm.selectedType"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Bedrag")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-euro-sign fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "text-right",
    attrs: {
      "type": "number",
      "step": "any",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.paymentForm.amount),
      callback: function($$v) {
        _vm.$set(_vm.paymentForm, "amount", $$v)
      },
      expression: "paymentForm.amount"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Datum")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-alt fa-fw"
  })]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "format": _vm.convertDate,
      "input-class": "text-right form-control date-field"
    },
    model: {
      value: (_vm.paymentForm.date),
      callback: function($$v) {
        _vm.$set(_vm.paymentForm, "date", $$v)
      },
      expression: "paymentForm.date"
    }
  })], 1)], 1)]), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "pull-right",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "title": "Opslaan"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-save"
  })])], 1), _vm._v(" "), _c('delete-dialog-modal', {
    ref: "deleteModal",
    attrs: {
      "delete-name": _vm.paymentList.selectedDeleteName,
      "item": _vm.paymentList.selectedDeletePayment,
      "isDeleting": _vm.paymentList.isDeleting
    },
    on: {
      "confirm": _vm.deletePayment
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isFetching) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('h3', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('common.invoice')))]), _vm._v(" "), (_vm.costs.person) ? _c('b-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.downloadInvoice($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('common.date')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.invoiceForm.date),
      callback: function($$v) {
        _vm.$set(_vm.invoiceForm, "date", $$v)
      },
      expression: "invoiceForm.date"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": _vm.$t('common.invoiceType')
    }
  }, [_c('multiselect', {
    attrs: {
      "placeholder": "Select one",
      "label": "text",
      "showLabels": false,
      "options": _vm.invoiceTypes,
      "searchable": false,
      "multiple": false
    },
    model: {
      value: (_vm.invoiceForm.type),
      callback: function($$v) {
        _vm.$set(_vm.invoiceForm, "type", $$v)
      },
      expression: "invoiceForm.type"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('buyerCost.note')
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": 3,
      "max-rows": 6
    },
    model: {
      value: (_vm.invoiceForm.note),
      callback: function($$v) {
        _vm.$set(_vm.invoiceForm, "note", $$v)
      },
      expression: "invoiceForm.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-btn-group', {
    staticClass: "pull-right"
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "primary",
      "disabled": _vm.isEmailing,
      "title": _vm.$t('common.emailInvoice')
    },
    on: {
      "click": _vm.emailInvoiceModal
    }
  }, [_c('fa-icon', {
    attrs: {
      "icon": "envelope",
      "fixed-width": ""
    }
  })], 1), _vm._v(" "), _c('loader-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "primary",
      "type": "submit",
      "title": _vm.$t('common.downloadReport'),
      "iconName": "file-pdf",
      "loading": _vm.isDownloading
    }
  })], 1)], 1), _vm._v(" "), _c('modal', {
    ref: "emailModal",
    attrs: {
      "size": "lg",
      "title": ("" + (_vm.$t('common.emailInvoice')))
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": 6,
      "max-rows": 6
    },
    model: {
      value: (_vm.invoiceForm.email_text),
      callback: function($$v) {
        _vm.$set(_vm.invoiceForm, "email_text", $$v)
      },
      expression: "invoiceForm.email_text"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "type": "button",
      "variant": "outline-primary",
      "block": ""
    },
    on: {
      "click": _vm.cancelEmailInvoiceModal
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cancel')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "type": "button",
      "disabled": _vm.isEmailing,
      "block": "",
      "variant": "primary"
    },
    on: {
      "click": _vm.emailInvoice
    }
  }, [_c('loader-spinner', {
    attrs: {
      "text": _vm.$t('common.emailInvoice'),
      "show-spinner": _vm.isEmailing
    }
  })], 1)], 1)])])])], 1)]) : _c('p', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('buyer.noPersonInvoice')) + "\n\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isFetching) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('h3', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('common.emailLogs')))]), _vm._v(" "), _c('email-logs-component', {
    attrs: {
      "isFetching": _vm.isFetching,
      "logs": _vm.costs.email_logs
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42505225"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/Buyer/BidNumberCost.vue
// module id = 1302
// module chunks = 1